/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Card_OpenInputs */

const cs_import_card_open = /** @type {(inputs: Import_Card_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít průvodce importem`)
};

const en_import_card_open = /** @type {(inputs: Import_Card_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open import wizard`)
};

/**
* | output |
* | --- |
* | "Open import wizard" |
*
* @param {Import_Card_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_card_open = /** @type {((inputs?: Import_Card_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Card_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_card_open(inputs)
	return cs_import_card_open(inputs)
});